import React from 'react';
import moment from 'moment';
import { Space, Switch } from 'antd';
import { useAtom } from 'jotai';
import { GRANULARITY } from '@src/utils/granularity';
import {
  granularityAtom,
  intervalAtom,
  tableViewSwitchAtom,
} from '@src/components/usage-dashboard/atoms';
import UsageDatePicker from './DatePicker/UsageDatePicker';
import MonthlySummary from './MonthlySummary';
import HelpRedirect from '@src/components/common/HelpRedirect';
import { USAGE_DB_HELP } from '@src/utils/help/links';

import { ApiUsageScopeToggle } from '../../apiUsageScope';

const UsageSummary = ({ isCustomerListFetching }) => {
  const [dateInterval, setDateInterval] = useAtom(intervalAtom);
  const [granularity, setGranularity] = useAtom(granularityAtom);
  const [tableViewOpen, setTableViewOpen] = useAtom(tableViewSwitchAtom);

  const onRangeChange = (dates) => {
    if (dates) {
      const today: any = moment();

      const from: any = dates[0].startOf('month');
      let to: any = dates[1].endOf('month');

      if (dates[1].isSame(today, 'month')) {
        to = today;
      }

      setDateInterval([from, to]);
      if (granularity === GRANULARITY.P1W) {
        setGranularity(GRANULARITY.P1D);
      }
    }
  };

  return (
    <>
      <div style={{ display: 'flex', marginTop: 10 }}>
        <div style={{ marginLeft: 'auto', marginRight: 0 }}>
          <Space size={16}>
            <ApiUsageScopeToggle />
            <HelpRedirect redirectUrl={USAGE_DB_HELP} />
            <Space>
              <Switch checked={tableViewOpen} onChange={(v) => setTableViewOpen(v)} />
              <span style={{ color: 'rgba(0, 0, 0, 0.88)' }}>Table View</span>
            </Space>
            <UsageDatePicker
              onRangeChange={onRangeChange}
              defaultValue={dateInterval}
              disabledGranularity={tableViewOpen}
            ></UsageDatePicker>
          </Space>
          <div style={{ margin: 0, fontSize: 'x-small', textAlign: 'right', paddingRight: 25 }}>
            Timezone In UTC
          </div>
        </div>
      </div>
      {isCustomerListFetching || tableViewOpen ? '' : <MonthlySummary />}
    </>
  );
};

export default UsageSummary;
